export default __webpack_public_path__ + "static/media/Loredo.a30bec81.png";